import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-h5 text-md-h4 font-weight-bold mb-4" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "d-flex flex-column align-start" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 2,
  class: "text-error"
}

import liquipediaIcon from '@/assets/imgs/liquipedia.png';
import youtubeIcon from '@/assets/imgs/youtube.png';
import tiktokIcon from '@/assets/imgs/tiktok.png';
import soopIcon from '@/assets/imgs/soop.png';
import twitchIcon from '@/assets/imgs/twitch.png';
import instagramIcon from '@/assets/imgs/instagram.webp';
import twitterIcon from '@/assets/imgs/twitter.png';
import redditIcon from '@/assets/imgs/reddit.png';
import w3championsIcon from '@/assets/imgs/w3c.png';

import { ref, computed, onMounted } from 'vue';
import DOMPurify from 'dompurify';
import { useRoute } from 'vue-router';
import { Article } from '@/services/news/article.model';
import { getArticleBySlug } from '@/services/news/article.service';
import { Platform } from '@/components/ArticleCard/ArticleCard.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticlePage',
  setup(__props) {

const route = useRoute();

const article = ref<Article | null>(null);
const loading = ref(true);
const errorMessage = ref<string | null>(null);

async function fetchArticle() {
  const slug = route.params.slug as string;
  try {
    loading.value = true;
    const data: any = await getArticleBySlug(slug);
    article.value = data;
  } catch (err) {
    errorMessage.value = 'Failed to load article.';
  } finally {
    loading.value = false;
  }
}

onMounted(fetchArticle);

const safeContribution = computed(() => DOMPurify.sanitize(article.value?.content || ''));

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "d-flex justify-center py-10" }, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
            key: 0,
            indeterminate: "",
            color: "primary",
            class: "d-flex mx-auto my-6"
          }))
        : (article.value)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 1,
              class: "pa-6",
              width: "1000",
              elevation: "2"
            }, {
              default: _withCtx(() => [
                (article.value.image)
                  ? (_openBlock(), _createBlock(_component_v_img, {
                      key: 0,
                      src: article.value.image,
                      width: "100%",
                      "aspect-ratio": "5/3",
                      class: "rounded-lg mb-4",
                      cover: ""
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true),
                _createElementVNode("h1", _hoisted_1, _toDisplayString(article.value.title), 1),
                _createElementVNode("div", {
                  innerHTML: safeContribution.value,
                  class: "mb-6"
                }, null, 8, _hoisted_2),
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.value.links, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "d-flex align-center mb-2"
                    }, [
                      (item.platform === _unref(Platform).YOUTUBE)
                        ? (_openBlock(), _createBlock(_component_v_img, {
                            key: 0,
                            src: _unref(youtubeIcon),
                            width: "20",
                            height: "20",
                            class: "me-2"
                          }, null, 8, ["src"]))
                        : (item.platform === _unref(Platform).W3CHAMPIONS)
                          ? (_openBlock(), _createBlock(_component_v_img, {
                              key: 1,
                              src: _unref(w3championsIcon),
                              width: "20",
                              height: "20",
                              class: "me-2"
                            }, null, 8, ["src"]))
                          : (item.platform === _unref(Platform).LIQUIPEDIA)
                            ? (_openBlock(), _createBlock(_component_v_img, {
                                key: 2,
                                src: _unref(liquipediaIcon),
                                width: "20",
                                height: "20",
                                class: "me-2"
                              }, null, 8, ["src"]))
                            : (item.platform === _unref(Platform).TWITCH)
                              ? (_openBlock(), _createBlock(_component_v_img, {
                                  key: 3,
                                  src: _unref(twitchIcon),
                                  width: "20",
                                  height: "20",
                                  class: "me-2"
                                }, null, 8, ["src"]))
                              : (item.platform === _unref(Platform).TIKTOK)
                                ? (_openBlock(), _createBlock(_component_v_img, {
                                    key: 4,
                                    src: _unref(tiktokIcon),
                                    width: "20",
                                    height: "20",
                                    class: "me-2"
                                  }, null, 8, ["src"]))
                                : (item.platform === _unref(Platform).SOOP)
                                  ? (_openBlock(), _createBlock(_component_v_img, {
                                      key: 5,
                                      src: _unref(soopIcon),
                                      width: "20",
                                      height: "20",
                                      class: "me-2"
                                    }, null, 8, ["src"]))
                                  : (item.platform === _unref(Platform).INSTAGRAM)
                                    ? (_openBlock(), _createBlock(_component_v_img, {
                                        key: 6,
                                        src: _unref(instagramIcon),
                                        width: "20",
                                        height: "20",
                                        class: "me-2"
                                      }, null, 8, ["src"]))
                                    : (item.platform === _unref(Platform).TWITTER)
                                      ? (_openBlock(), _createBlock(_component_v_img, {
                                          key: 7,
                                          src: _unref(twitterIcon),
                                          width: "20",
                                          height: "20",
                                          class: "me-2"
                                        }, null, 8, ["src"]))
                                      : (item.platform === _unref(Platform).REDDIT)
                                        ? (_openBlock(), _createBlock(_component_v_img, {
                                            key: 8,
                                            src: _unref(redditIcon),
                                            width: "20",
                                            height: "20",
                                            class: "me-2"
                                          }, null, 8, ["src"]))
                                        : (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 9,
                                            icon: "mdi-link-variant",
                                            size: "18",
                                            class: "me-2"
                                          })),
                      _createElementVNode("a", {
                        href: item.link,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        class: "text-body-2 text-decoration-none"
                      }, _toDisplayString(item.description), 9, _hoisted_4)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }))
          : (errorMessage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})